import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert, AlertType } from '../../models/Alert';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private subject = new Subject<Alert>();

    constructor(private router: Router) {
    }

    // subscribe to alerts
    getAlert(alertId?: string): Observable<any> {
        return this.subject.asObservable().pipe(filter((x: Alert) => x && x.alertId === alertId));
    }

    // convenience methods
    success(message: string, timeout: number) {
        this.alert(new Alert({ message, type: AlertType.Success }));
        window.setTimeout(() => {
            this.clear();
        }, timeout);
    }

    error(message: string, timeout: number) {
        this.alert(new Alert({ message, type: AlertType.Error }));
        window.setTimeout(() => {
            this.clear();
        }, timeout);
    }

    info(message: string, timeout: number) {
        this.alert(new Alert({ message, type: AlertType.Info }));
        window.setTimeout(() => {
            this.clear();
        }, timeout);
    }

    warn(message: string, timeout: number) {
        this.alert(new Alert({ message, type: AlertType.Warning }));
        window.setTimeout(() => {
            this.clear();
        }, timeout);
    }

    // main alert method
    alert(alert: Alert) {
        this.subject.next(alert);
    }

    // clear alerts
    clear(alertId?: string) {
        this.subject.next(new Alert({ alertId }));
    }
}